<template>
  <div class="sign-up">
    <section class="left-panel">
      <header>
        <div class="grid-container top">
          <div class="col-4">
            <img class="logo" src="../assets/images/global/logo.svg">
          </div>
        </div>
      </header>
      <div class="grid-container">
        <div class="col-4 vertical-centre">

          <div class="left-panel-centre" v-if="!added">

            <h1><span style="color: #1ba4db;">Join us as we build </br><span style="color: #00AE8F;">PEI</span> ex<span style="color: #327CA2;">Change</span></span></h1>

            <p style="font-size: 1.28em; padding-bottom: 13px;" class="large">The first ever matching platform for people passionate about African development.</p>

            <h4 style="color: #1ba4db; font-family: 'Apercu-medium', sans-serif; color: #1ba4db;">Sign up for early access:</h4>

            <form @submit.prevent="register">
              <input class="" type="email" v-model.trim="email" placeholder="someone@example.com" required />
              <input class="btn btn-big bg-two active" style="background-position: center 553px;" type="submit" value="Yes, I'm In!">

              <span style="color: #7B7E80; opacity: 0.6; position: relative; top: 16px;">We promise to never spam you!</span>
            </form>

          </div>

          <div class="left-panel-centre" v-else-if="added">

            <h1 class="small"><span>Thanks!</span> We'll email you when our registration process opens.</h1>

          </div>


        </div>
        <ul class="bottom">
          <h3 style="color: #1ba4db;">#BigIdeasforAfrica</h3>
          <li><a target="_blank" href="http://planetearthinstitute.org.uk" class="link blue">Visit PEI Website</a></li>
          <li><router-link to="/about" class="link blue">About PEI exChange</router-link></li>
        </ul>
      </div>
    </section>
    <section class="hero-image">
    </section>
  </div>
</template>

<script>
import { db } from '@/firebase'
// import dateFormat from 'dateformat'

export default {
  name: 'Register',
  data () {
    return {
      email: '',
      added: false,
      now: Date.now()
    }
  },
  methods: {
    register () {
      if (this.email) {
        let parent = this
        // let formatted = dateFormat(this.now, 'h:MM:ss TT - dS mmmm yyyy')
        db.ref('pre-registration').push({
          email: this.email,
          when: this.now
        }, function () {
          // On complete
          parent.added = true
        })
      } else {
        console.error('no email given')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?5cce45d7